import service from './index';

//添加底图设置信息
export function addBaseMapSetting(params) {
    return service.post(`/api/v1/basemapsetting/addBaseMapSetting`, params)
}

//设置默认底图
export function baseMapSettingDefault(id) {
    return service.put(`/api/v1/basemapsetting/baseMapSettingDefault?baseMapId=${id}`)
}

//取消所有默认底图
export function cancelBaseMapSettingDefault(id) {
    return service.put(`/api/v1/basemapsetting/cancelBaseMapSettingDefaultById?baseMapId=${id}`)
}

//删除底图配置信息
export function deleteBaseMapSetting(id) {
    return service.delete(`/api/v1/basemapsetting/deleteBaseMapSetting?baseMapId=${id}`)
}

//获取所有默认底图
export function getBaseMapSettingDefault() {
    return service.get(`/api/v1/basemapsetting/getBaseMapSettingDefault`)
}

//获取底图配置信息列表
export function getBaseMapSettings(params) {
    return service.get(`/api/v1/basemapsetting/getBaseMapSettings?pageNum=${params.pageNum}&pageSize=${params.pageSize}&keyWords=${params.keyWords}`)
}

//上移或下移底图配置信息
export function baseMapSettingUpAndDown(params) {
    return service.put(`/api/v1/basemapsetting/baseMapSettingUpAndDown?baseMapId=${params.baseMapId}&upDown=${params.upDown}`)
}